import {combineReducers} from 'redux';

const isMenuVisibleReducer = (isMenuVisible = false, action) => {
    if (action.type === 'MENU_VISIBLE') {
        return action.payload;
    }
    return false;
};

const isPageVisibleReducer = (isPageVisible = false, action) => {
    if (action.type === 'PAGE_VISIBLE') {
        return action.payload;
    }
    return true;
};

const playCutSceneVideoReducer = (cutSceneVideo = {}, action) => {
    if (action.type === 'CUT_SCENE_VIDEO') {
        return action.payload;
    }
    return {
        nextPath: "",
        visible: true,
        url: "/videos/ol_loading_index_all_75-01.mp4",
    };
};

const pageChangeReducer = (pageInfo = {}, action) => {
    if (action.type === 'PAGE_CHANGE') {
        return action.payload;
    } else {
        return {
            prevUrl: "",
            nextUrl: ""
        };
    }
}

const languageChangeReducer = (language = "", action) => {
    if (action.type === 'LANGUAGE_CHANGE') {
        return action.payload;
    } else {
        return localStorage.getItem("language");
    }
}

export default combineReducers({
    isMenuVisible: isMenuVisibleReducer,
    isPageVisible: isPageVisibleReducer,
    cutsceneVideo: playCutSceneVideoReducer,
    pageInfo: pageChangeReducer,
    language: languageChangeReducer
});